import { XIcon } from "@heroicons/react/outline";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { type OfflineTaskUpload } from "~/config/offline-storage/offlineTaskUploads.store";
import { Box } from "~/design-system/Box";
import { Button } from "~/design-system/Button";
import { Text } from "~/design-system/Text";

interface PendingUploadItemProps {
  upload: OfflineTaskUpload;
  onRemove: (upload: OfflineTaskUpload) => void;
}

export const PendingUploadItem: React.FC<PendingUploadItemProps> = ({
  onRemove,
  upload,
}) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Box
        css={{
          alignItems: "center",
          display: "flex",
          gap: "$xxsmall",
          justifyContent: "space-between",
        }}
      >
        <Box css={{ flex: 1, minWidth: 0 }}>
          <Text
            size="xsmall"
            tone="neutral"
            css={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {upload.fileName}
          </Text>
          {upload.retryCount > 0 && (
            <Text size="xsmall" tone="caution" css={{ marginTop: "$xxsmall" }}>
              Retry {upload.retryCount}
            </Text>
          )}
        </Box>
        <Button
          size="xsmall"
          variant="ghost"
          circular
          onClick={() => onRemove(upload)}
          iconLabel="Remove file"
        >
          <XIcon height={12} width={12} />
        </Button>
      </Box>
    </Box>
  );
};
